import produce from 'immer'
import { getTiposPersonalizacion } from '../../utiles/tiposPersonalizacion'
import { actions } from './actions'

const tiposPersonalizacion = getTiposPersonalizacion()

const initialState = {
  personalizacionProducto: {
    data: tiposPersonalizacion.map(tipo => {
      return {
        ...tipo,
        cantidad: null,
      }
    }),
    loading: false,
    error: '',
  },
}

export default function personalizacionProductoReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_PERSONALIZACION_BY_PRODUCTO_REQUESTED: {
      return {
        ...state,
        personalizacionProducto: { ...state.personalizacionProducto, loading: true },
      }
    }
    case actions.GET_PERSONALIZACION_BY_PRODUCTO_SUCCEEDED:
      return {
        ...state,
        personalizacionProducto: {
          ...state.personalizacionProducto,
          data: action.payload,
          loading: false,
        },
      }
    case actions.GET_PERSONALIZACION_BY_PRODUCTO_FAILED:
      return {
        ...state,
        personalizacionProducto: {
          ...state.personalizacionProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.CHOCOMENSAJE_PRODUCTO_DELETED: {
      const newState = produce(state, draftState => {
        draftState.personalizacionProducto.data.chocomensaje.personalizacion.chocomensajeProducto = null
      })
      return newState
    }
    case actions.IMAGEN_CLIENTE_PRODUCTO_DELETED: {
      const newState = produce(state, draftState => {
        draftState.personalizacionProducto.data.imagenCliente.personalizacion.imagenClienteProducto = null
      })
      return newState
    }
    case actions.IMAGEN_CLIENTE_PRODUCTO_INSERTED: {
      const imagenCliente = action.payload
      const newState = produce(state, draftState => {
        draftState.personalizacionProducto.data.imagenCliente.personalizacion.imagenClienteProducto = imagenCliente
      })
      return newState
    }
    case actions.AUDIO_PRODUCTO_DELETED: {
      const newState = produce(state, draftState => {
        draftState.personalizacionProducto.data.audio.personalizacion = null
      })
      return newState
    }
    case actions.AUDIO_PRODUCTO_INSERTED: {
      const audioProducto = action.payload
      const newState = produce(state, draftState => {
        draftState.personalizacionProducto.data.audio.personalizacion = audioProducto
      })
      return newState
    }
    case actions.INSERT_LEGOPROPS_PRODUCTO_REQUESTED: {
      return {
        ...state,
        personalizacionProducto: { ...state.personalizacionProducto, loading: true },
      }
    }
    case actions.INSERT_LEGOPROPS_PRODUCTO_SUCCEEDED: {
      const legoProps = action.payload
      const newState = produce(state, draftState => {
        draftState.personalizacionProducto.data.legoProps.personalizacion = legoProps
        draftState.personalizacionProducto.loading = false
      })
      return newState
    }
    case actions.INSERT_LEGOPROPS_PRODUCTO_FAILED:
      return {
        ...state,
        personalizacionProducto: {
          ...state.personalizacionProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.UPDATE_LEGOPROPS_PRODUCTO_REQUESTED: {
      return {
        ...state,
        personalizacionProducto: { ...state.personalizacionProducto, loading: true },
      }
    }
    case actions.UPDATE_LEGOPROPS_PRODUCTO_SUCCEEDED: {
      const legoProps = action.payload
      const newState = produce(state, draftState => {
        draftState.personalizacionProducto.data.legoProps.personalizacion = legoProps
        draftState.personalizacionProducto.loading = false
      })
      return newState
    }
    case actions.UPDATE_LEGOPROPS_PRODUCTO_FAILED:
      return {
        ...state,
        personalizacionProducto: {
          ...state.personalizacionProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_LEGOPROPS_PRODUCTO_REQUESTED: {
      return {
        ...state,
        personalizacionProducto: { ...state.personalizacionProducto, loading: true },
      }
    }
    case actions.DELETE_LEGOPROPS_PRODUCTO_SUCCEEDED: {
      const newState = produce(state, draftState => {
        draftState.personalizacionProducto.data.legoProps.personalizacion = null
        draftState.personalizacionProducto.loading = false
      })
      return newState
    }
    case actions.DELETE_LEGOPROPS_PRODUCTO_FAILED:
      return {
        ...state,
        personalizacionProducto: {
          ...state.personalizacionProducto,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
